module.exports = __webpack_public_path__ + "static/newJoin-3-07203ff8b9428e38b1dc9ba8d6dc171a.jpg";